import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "./AxiosInstance";

const initialState = {
  posts: [],
  status: "idle",
  error: null,
};

export const fetchBankMaster = createAsyncThunk("posts/fetchPosts", async ({ url, FormDataDynamic }) => {
  try {
    const formData = new FormData();

    Object.keys(FormDataDynamic).forEach((key) => {
      const value = FormDataDynamic[key];

      // ✅ Agar value array hai (jaise multi-file upload: compressedFiles[])
      // to har item ko same key ke naam se alag-alag append karo,
      // taaki backend usse ek file-array ki tarah receive kare
      // (pehle poora array `.toString()` ho ke "[object Blob]" ban jaata tha).
      if (Array.isArray(value)) {
        value.forEach((item) => {
          formData.append(key, item);
        });
      } else {
        formData.append(key, value);
      }
    });

    const response = await axiosInstance.post(url, formData, {
      headers: {
        Accept: "*/*",
      },
    });

    return response && response.data;
  } catch (error) {
    console.error("Error fetching posts:", error);
    throw error;
  }
});

const getBankMasterSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBankMaster.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBankMaster.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.posts = action.payload;
      })
      .addCase(fetchBankMaster.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default getBankMasterSlice.reducer;